/* eslint-disable max-len */
/* global PLATFORM, G */
import { set as setToken } from 'app/_shared/component/token'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import { getFirstItem } from 'lib/util'

/**
 * Assemble the title of the request detail action by either getting the ticket number or translating
 * its status if there is no number and add the result to the component's tokens.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): *[]}
 */
const uiTitle = obj => (...args) => {
  const action = obj[G.STATE][G.ACTION]
  const component = action[G.COMPONENT]

  const { number = null, status, submit: { timestamp = null } = {} } = obj[G.MODEL][G.CACHE].value
  const submitDate = obj[G.ADAPTER][G.INTL].getLocaleDate(timestamp, { dateStyle: 'short' })

  const { value: currentStatus = null } = getFirstItem(listRequestStatus(obj, component, { detail: { key: status } }))
    || {}

  const numberOrStatus = number || `(${currentStatus?.value})`
  setToken(obj, { numberOrStatus })

  if (PLATFORM === 'mobile') {
    const subTitle = [currentStatus, submitDate]
      .filter(x => !!x)
      .reduce((acc, key, i, arr) => [...acc, key, ...i < arr.length - 1 ? ['•'] : []], [])
      .join(' ')

    number && (action[G.UI].title = number)
    action[G.UI].subTitle = subTitle
  }

  return args
}

export default uiTitle
